import tourvisorAPI from '../../api/tourvisorAPI';

// Интерфейс для класса, представляющего запрос на получение туров
class TourRequest {

  REQUEST_KEYS_MAP = {
    countryId: 'country',
    cityFromId: 'departure',
    s_departFrom: 'datefrom',
    s_departTo: 'dateto',
    nightsfrom: 'nightsfrom',
    nightsto: 'nightsto',
    pricefrom: 'pricefrom',
    priceto: 'priceto',
    service: 'services',
    cities: 'region',
    subregion: 'subregion',
    operators: 'operators',
    pageSize: 'onpage',
    visibleOperators: 'operators',
    currencyAlias: 'currency',
    child: 'child',
    adults: 'adults'
  }

  constructor(request) {
    this.requestData = request || {}; // Данные запроса на получение туров
    this.cleanPrepare();
  }


  cleanPrepare() {
    const data = {}
    let requestExtendKeysList = Object.keys(this.requestData);
    requestExtendKeysList.map( key => {
      // фиксим request в каждой итерации
      data[this.REQUEST_KEYS_MAP[key]] = this.requestData[key];
    });

    // fix date to/ date from
    if (data.datefrom) {
      data.datefrom = data.datefrom.split('/').join('.');
    }
    if (data.dateto) {
      data.dateto = data.dateto.split('/').join('.');
    }

    // if (data.operators) {
    //   data.operators = data.operators.(',');
    // }

    this.requestData = data;
    console.warn('CLEAN ', this.requestData);
    return this;
    // нормализация запроса
  }

  /*
   * Метод для отправки запроса на получение туров
   * return {}
   *
   * может вернуть ошибку, requestId или данные из кэша
   */
  async send() {
    try {
      const response = await tourvisorAPI.search(this.requestData);
      if (response && response.error) {
        console.warn('ТУРЫ ОШИБКА');
        console.error(response.error.errormessage);
        return 0;
      } else if (response && response.data) {
        console.warn('ТУРЫ КЭШ');
        return response.data;
      } else if (response && response.result && response.result.requestid ) {
        console.warn('REQUEST_ID СЕРВЕР');
        return +response.result.requestid;
      }
      console.warn('ТУРЫ НИЧЕГО');
      return 0;
    } catch (error) {
      console.error('Ошибка при отправке запроса на получение туров:', error);
      throw error;
    }
  }
}

export default TourRequest;